import { convertToInternationalCurrencySystem } from "../../utils/utils";
import dateFormat from "dateformat";
import styled from "styled-components";
import Tooltip from "../Tooltip/Tooltip";

const Wrapper = styled.div`
  &.custom-tooltip {
    padding: 0 0 0 10px;
    color: #e0ecff;
    z-index: 2;
    .tip-title {
      font-size: 16px;
      color: #e0ecff;
    }
    .value {
      font-size: 32px;
      font-weight: 700;
      font-family: Barlow;
    }
    .date {
      margin-top: 4px;
      margin-left: 4px;
      font-size: 14px;
      height: 14px;
    }
    .text {
      border-bottom: 1px dashed #93a1b8;
      width: max-content;
      cursor: pointer;
      display: block;
    }
  }
`;

const RechartTooltip = ({
  title,
  active,
  payload,
  lastItem,
  decimalScale = 2,
  tip,
  id = String(new Date().getTime()) + Math.random(),
  isTime = false,
}: {
  title?: any;
  active?: any;
  payload?: any;
  lastItem?: any;
  decimalScale?: number;
  tip?: any;
  id?: any;
  isTime?: boolean;
}) => {
  if (active && payload && payload.length) {
    return (
      <Wrapper className="custom-tooltip">
        <div className="tip-title">{title}</div>
        <div className="value">
          {payload[0].payload.name && payload[0].payload.name}
          {tip ? (
            <>
              <span data-for={id} data-tip={tip} className="text">
                {convertToInternationalCurrencySystem(
                  payload[0].payload.value,
                  decimalScale
                )}
              </span>
              <Tooltip id={id} width={400} padding="12" place="bottom">
                {" "}
                {tip}{" "}
              </Tooltip>
            </>
          ) : (
            convertToInternationalCurrencySystem(
              payload[0].payload.value,
              decimalScale
            )
          )}
        </div>
        <div className="date">
          {payload[0].payload.time &&
            `${dateFormat(
              new Date(payload[0].payload.time * 1000),
              "UTC:yyyy-mm-dd"
            )}(UTC)`}
        </div>
      </Wrapper>
    );
  } else if (title && lastItem.value) {
    return (
      <Wrapper className="custom-tooltip">
        <div className="tip-title">{title}</div>
        <div className="value">
          {" "}
          {lastItem.name && lastItem.name}{" "}
          {tip ? (
            <>
              <span data-for={id} data-tip={tip} className="text">
                {convertToInternationalCurrencySystem(
                  lastItem.value,
                  decimalScale
                )}
              </span>
              <Tooltip width={400} id={id} padding="12" place="bottom">
                {" "}
                {tip}{" "}
              </Tooltip>
            </>
          ) : (
            convertToInternationalCurrencySystem(lastItem.value, decimalScale)
          )}
        </div>
        <div className="date">
          {isTime
            ? lastItem.timestamp &&
              `${dateFormat(
                new Date(lastItem.timestamp * 1000),
                "UTC:yyyy-mm-dd hh:MM:ss"
              )}(UTC)`
            : lastItem.timestamp &&
              `${dateFormat(
                new Date(lastItem.timestamp * 1000),
                "UTC:yyyy-mm-dd"
              )}(UTC)`}
        </div>
      </Wrapper>
    );
  }
  return null;
};
export default RechartTooltip;
